import { ForwardedRef, forwardRef, useMemo } from "react";
import { SelectInstance } from "react-select";
import SimpleSelect, { SimpleSelectProps } from "./Simple";

type AnyEnum = {
  [id: string]: string;
  [idx: number]: string;
};

type Option<TEnum> = { value: TEnum; label: string };

type Props<TEnum, IsMulti extends boolean = false> = Omit<
  SimpleSelectProps<keyof TEnum, IsMulti>,
  "values"
> & {
  enum: TEnum;
};

function EnumSelect<TEnum, IsMulti extends boolean = false>(
  { isMulti, enum: enumObj, ...rest }: Props<TEnum, IsMulti>,
  ref: ForwardedRef<SelectInstance<Option<keyof TEnum>, IsMulti>>,
) {
  const values = useMemo(
    () => Object.keys(enumObj as AnyEnum) as (keyof TEnum)[],
    [enumObj],
  );
  return (
    <SimpleSelect<keyof TEnum, IsMulti>
      {...{ ref, isMulti, values }}
      {...rest}
    />
  );
}

export default forwardRef(EnumSelect);
